// 路由（任务 1.7 + 3.x + M4 导航修复/落地页 + 099 运营后台）· 公开页：落地/引导/安全承诺；应用页：工作台/表单/进度/结果/编辑器；运营后台：/dashboard
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth";
import Landing from "./pages/Landing";
import Guide from "./pages/Guide";
import Security from "./pages/Security";
import Login from "./pages/Login";
import Projects from "./pages/Projects";
import NewProject from "./pages/NewProject";
import Workspace from "./pages/Workspace";
import Deck from "./pages/Deck";
import Editor from "./pages/Editor";
import V2Preview from "./pages/V2Preview";
import DashboardLayout from "./pages/dashboard/DashboardLayout";
import DashOverview from "./pages/dashboard/Overview";
import DashTraffic from "./pages/dashboard/Traffic";
import DashUsers from "./pages/dashboard/Users";
import DashProjects from "./pages/dashboard/Projects";
import DashProjectDetail from "./pages/dashboard/ProjectDetail";
import DashGenCost from "./pages/dashboard/GenCost";
import DashSiteHealth from "./pages/dashboard/SiteHealth";
import DashIssues from "./pages/dashboard/Issues";
import type { ReactNode } from "react";

function Protected({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-center text-muted">加载中…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      {/* 公开页（M4.2）：新访客 3 分钟看懂价值与隐私承诺 */}
      <Route path="/" element={<Landing />} />
      <Route path="/guide" element={<Guide />} />
      <Route path="/security" element={<Security />} />
      <Route path="/login" element={<Login />} />
      <Route path="/v2preview" element={<V2Preview />} />
      {/* 应用页 */}
      <Route path="/projects" element={<Protected><Projects /></Protected>} />
      {/* 099 D01：旧 /admin 成本看板统一并入 /dashboard/cost，外链兼容重定向 */}
      <Route path="/admin" element={<Navigate to="/dashboard/cost" replace />} />
      <Route path="/new" element={<Protected><NewProject /></Protected>} />
      <Route path="/job/:jobId" element={<Protected><Workspace /></Protected>} />
      <Route path="/deck/:deckId" element={<Protected><Deck /></Protected>} />
      <Route path="/deck/:deckId/edit" element={<Protected><Editor /></Protected>} />
      {/* 099 运营后台：登录 + 服务端 /admin/me 授权闸（Layout 内）双层 */}
      <Route path="/dashboard" element={<Protected><DashboardLayout /></Protected>}>
        <Route index element={<DashOverview />} />
        <Route path="traffic" element={<DashTraffic />} />
        <Route path="users" element={<DashUsers />} />
        <Route path="projects" element={<DashProjects />} />
        <Route path="projects/:id" element={<DashProjectDetail />} />
        <Route path="cost" element={<DashGenCost />} />
        <Route path="site" element={<DashSiteHealth />} />
        <Route path="issues" element={<DashIssues />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
